import { IconDefinition } from "./types";

const user: IconDefinition = {
  iconName: "user",
  width: 16,
  height: 16,
  svgPathData:
    "M8 8a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM1.5 15c0-3.313 2.91-6 6.5-6s6.5 2.687 6.5 6",
  iconType: "stroke",
};

export { user };
